'use client';

import { Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { Stack } from '@mui/material';
import { Button } from '@prismo-io/design-system';
import { env } from '@prismo-io/env';
import { Application, translate } from '@prismo-io/router';
import { ComingFromType, LanguageCode, type LanguageCodeT } from '@prismo-io/schemas';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { type FC, useMemo } from 'react';
type Props = unknown;
const buildSignInUrl = (locale: LanguageCodeT, pathname: string) => {
  // eslint-disable-next-line no-constant-condition, prettier/prettier
  return translate({
    app: Application.ONBOARDING,
    path: `/connexion`,
    queryParams: {
      comingFrom: ComingFromType.Enum.APP,
      redirectTo: new URL(pathname, env.NEXT_PUBLIC_APP_URL).toString()
    },
    addHostname: true,
    locale
  });
};
const buildSignUpUrl = (locale: LanguageCodeT, pathname: string) => {
  // eslint-disable-next-line no-constant-condition, prettier/prettier
  return translate({
    app: Application.ONBOARDING,
    path: `/inscription`,
    queryParams: {
      comingFrom: ComingFromType.Enum.APP,
      redirectTo: new URL(pathname, env.NEXT_PUBLIC_APP_URL).toString()
    },
    addHostname: true,
    locale
  });
};
export const SignInUpBtnsContainer: FC = () => {
  const {
    i18n
  } = useLingui();
  const {
    locale = LanguageCode.Enum.fr
  } = i18n;
  const pathname = usePathname();
  const signInUrl = useMemo(() => buildSignInUrl(locale as LanguageCodeT, pathname), [locale, pathname]);
  const signUpUrl = useMemo(() => buildSignUpUrl(locale as LanguageCodeT, pathname), [locale, pathname]);
  return <Stack direction="row" justifyContent="flex-end" alignItems="center" gap={2} width="fit-content" data-sentry-element="Stack" data-sentry-component="SignInUpBtnsContainer" data-sentry-source-file="index.tsx">
      <Button LinkComponent={Link} href={signInUrl} variant="outlined" sx={{
      backgroundColor: 'white',
      '& .MuiButton-startIcon': {
        display: 'none'
      }
    }} data-sentry-element="Button" data-sentry-source-file="index.tsx">
        <Trans data-sentry-element="Trans" data-sentry-source-file="index.tsx">Connexion</Trans>
      </Button>
      <Button LinkComponent={Link} href={signUpUrl} variant="contained" color="gradient" sx={{
      '& .MuiButton-startIcon': {
        display: 'none'
      }
    }} data-sentry-element="Button" data-sentry-source-file="index.tsx">
        <Trans data-sentry-element="Trans" data-sentry-source-file="index.tsx">Inscription</Trans>
      </Button>
    </Stack>;
};